import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 14H2v-2h16v2h-5zm-.606 4H7.606a9.139 9.139 0 0 0 .357-2h4.074c.062.818.196 1.478.357 2zM2 10h16V2H2v8zM19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4.951c-.157 1.657-.661 2.293-.659 2.293h.001A1 1 0 0 0 6 20h8a.996.996 0 0 0 .897-.598c.163-.356.09-.788-.166-1.084-.006-.007-.523-.641-.682-2.318H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
});

var SvgDesktopMajorMonotone = function SvgDesktopMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgDesktopMajorMonotone as S };
